module.exports = __webpack_public_path__ + "components/app-store/static/s4-e64c27203d280ce3ba17acc9663a3387.jpg";